﻿/**
 * 上传组件布局
 *
 * @author LCTR
 * @date 2022-06-24
 */
export enum Layout {
    卡片 = 'Card',
    清单 = 'Detailedly'
}